// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/password-input","toggleButton":"password-input-m__toggleButton__19rJx"};